// extracted by mini-css-extract-plugin
export default {"fieldsWrapper":"AssistantSetUp_fieldsWrapper__18pCh"};